import { observer } from 'mobx-react-lite';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { AccordionArrow } from '~/views/atoms/svg-icons/accordion-arrow';
import Typography from '@mui/material/Typography';
import { FC, useEffect } from 'react';

export const Support: FC = observer(() => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="container">
            <div className="support-wrap">
                <Accordion>
                    <AccordionSummary aria-controls="panel1-content" id="panel1-header" expandIcon={<AccordionArrow />}>
                        <Typography>How do I sign-in?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            To sign in to the webshop, you must have previously logged in using your phone number in one
                            of our apps that support "WDollars." Once you’ve logged in with your phone number in the
                            app, the webshop will recognize your account and grant you access.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel2-content" id="panel2-header" expandIcon={<AccordionArrow />}>
                        <Typography>What is Free Play?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Free Play refers to credits that you can redeem and use in participating land-based casinos.
                            These credits are earned as a bonus when you purchase WDollars through our webshop. Once
                            redeemed, these credits can be used to play games at selected casino locations.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel3-content" id="panel3-header" expandIcon={<AccordionArrow />}>
                        <Typography>How do I earn Free Play credits?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            You earn Free Play credits by purchasing WDollars from our webshop. The amount of Free Play
                            credits awarded depends on the WDollar package you choose.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel4-content" id="panel4-header" expandIcon={<AccordionArrow />}>
                        <Typography>How do I redeem my Free Play credits?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>To redeem your Free Play credits:</Typography>
                        <ol>
                            <li>
                                Log in to the webshop with your phone number (must be the same one used for Hard Rock
                                Neverland Casino or Hard Rock Jackpot Planet apps).
                            </li>
                            <li>Ensure your UNITY account is linked.</li>
                            <li>Navigate to the "Redeem Free Play" section.</li>
                            <li>Select the amount you wish to redeem (any amount between $10 and $1000).</li>
                            <li>Choose your preferred participating casino location from the dropdown menu.</li>
                            <li>Click "Redeem" and follow the confirmation prompts.</li>
                            <li>Redeemed Free Play credits will be added to your UNITY account within 48 hours.</li>
                        </ol>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel5-content" id="panel5-header" expandIcon={<AccordionArrow />}>
                        <Typography>What do I need to redeem Free Play credits?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            You must have a linked UNITY account to redeem Free Play credits. If you do not have one,
                            you will be prompted to create a UNITY account during the redemption process.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel7-content" id="panel7-header" expandIcon={<AccordionArrow />}>
                        <Typography>Are there any limits on how much Free Play I can redeem?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Yes, you can redeem Free Play credits in any amount between $10 and $1000 at a time.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel8-content" id="panel8-header" expandIcon={<AccordionArrow />}>
                        <Typography>What happens if I don’t redeem my Free Play credits?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Free Play credits expire 14 days after they are redeemed. Additionally, any Free Play
                            balance not redeemed within a calendar year will expire on June 30 of the following year,
                            giving you a 6-month buffer to use them.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary aria-controls="panel9-content" id="panel9-header" expandIcon={<AccordionArrow />}>
                        <Typography>How will I know when my Free Play credits are available?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Once you redeem your Free Play credits, they will be added to your UNITY account within 48
                            hours. You will receive an email confirmation once the credits have been added.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        aria-controls="panel10-content"
                        id="panel10-header"
                        expandIcon={<AccordionArrow />}
                    >
                        <Typography>Can I use Free Play credits at any casino?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Free Play credits can only be used at participating land-based casinos. You will be able to
                            choose your preferred location from a dropdown list during the redemption process.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        aria-controls="panel11-content"
                        id="panel11-header"
                        expandIcon={<AccordionArrow />}
                    >
                        <Typography>What should I do if I encounter issues during the redemption process?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            If you experience any issues while redeeming your Free Play credits, please contact our
                            support team at{' '}
                            <a href="mailto:customercare@hardrockgames.com">customercare@hardrockgames.com</a>. We are
                            here to help!
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
});
